export default {
    CustomerList: {
        ChooseCustomer: 'Vælg butik',
    },

    Customer: {
        SafesOnline: 'Skabe online',
        CurrentBalance: 'Nuværende balance',
        DailySales: 'Dagligt indskud',
        ActiveWarnings: 'Fejlmeddelelser',
        Of: 'af',
        In: 'i',
        Branches: 'Butikker'
    },

    Branch: {
        ExportTransactions: "Eksporter transaktioner",
        ManageOperators: "Vedligehold operatører",
        ShowOnMap: "Vis på kort",
        CurrentBalance: "Nuværende beholdning",
        DailySales: 'Dagligt indskud',
        MainCurrency: 'Hovedvaluta',
        TransactionDays: 'Transaktionsdage'
    },

    BranchList: {
        Name: 'Navn',
        Status: 'Status',
        BalanceAmount: 'Beholdning',
        BalanceCurrency: 'Valutabeholdning',
        LastBalance: 'Opdateret',
        Branches: 'Butikker',
    },

    BranchListFilter: {
        Branches: 'Butikker',
        SearchCriteria: 'Find butik...',
    },


    Chart: {
        Sales: 'Indskud',
        Pickup: 'Afhentning',
        Balance: 'Beholdning',
        Difference: 'Difference',
        Confirmed: 'Bekræftet',
        SalesBalancesAndPickups: 'Indskud, beholdninger & afhentninger',
        NoDataAvailable: 'Ingen data til rådighed',
        SafebagBalance: 'Samlet beholdning',
        RecyclableBalance: 'Beholdning til genbrug',
        ManualDepositBalance: 'Manuel indskud beholdning',
        OverflowBalance: 'Overskudsbeholdning'
    },

    ChartDenominations: {
        Deposited: 'Deponeret',
        Recyclable: 'Til genbrug',
        Denominations: 'Denominationer',
        NoDataAvailable: 'Ingen data til rådighed'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Auto indskud',
        UnprocessedSales: 'Manuelle indskud',
        SalesOut: 'Hævninger',
        SalesPerHour: 'Indskud pr. time'
    },

    CustomerHeader: {
        ShowOnMap: 'Vis på kort',
        Branches: 'Butikker',
        Branch: 'Butik',
        ExportTransactions: 'Transaktioner',
    },

    DeviceStatus: {
        AllOk: 'Alt ok',
    },

    DeviceStatusList: {
        Safes: 'Skabe',
    },

    ExportForm: {
        ExportTransactions: 'Eksporter transaktioner',
        Cancel: 'Fortryd',
        Export: 'Eksporter',
        FromDate: 'Fra dato',
        Time: 'Tidspunkt',
        EndDate: 'Til dato'
    },

    ForgotPasswordForm: {
        ForgotHeader: 'Har du glemt dit password?',
        ForgotText: 'Venligst indtast din email nedenfor og klik på knappen. Du vil herefter modtage en email med instrukser.',
        LoginLink: 'Tilbage til login',
        EmailAddress: 'Email-adresse',
        Submit: 'Send email',
        ErrorMessage: 'Vi er ikke i stand til at sende din forespørgsel til serveren.'
    },

    LoginPage: {
        LoginHeader: 'Velkommen',
        LoginText: 'Log ind med din email og dit password',
        LoginForgot: 'Har du glemt dit password?',
        Username: 'EMAIL',
        Password: 'PASSWORD',
        Login: 'Log ind'
    },

    ResetPasswordPage: {
        ResetHeader: 'Nulstil password',
        ResetText: 'Tast dit nye password.'
    },

    Drawer: {
        Dashboard: 'Overblik',
        SwitchCustomer: 'Skift kunde',
        MyProfile: 'Min profil',
        Logout: 'Log ud'
    },

    OperatorForm: {
        UserId: 'Operatør Id',
        FirstName: 'Fornavn',
        LastName: 'Efternavn',
        Pin: 'Pin',
        Save: 'Gem',
        Delete: 'Slet',
        Operator: 'Operatør'
    },

    OperatorList: {
        AddOperator: 'Tilføj Operatør',
        Operators: 'Operatører',
        Name: 'Navn'
    },

    Profile: {
        Profile: 'Profil',
        Name: 'Navn',
        Language: 'Sprog',
        Password: 'Password',
        ConfirmPassword: 'Bekræft password',
        Update: 'Opdater'
    },

    ResetPasswordForm: {
        NewPassword: 'Nyt Password',
        ConfirmPassword: 'Bekræft Password',
        Submit: 'Indsend'
    },

    InviteUserForm: {
        InviteHeader: 'Brugerinvitation',
        InviteText: 'Venligst udfyld dine data og tryk Gem for at kunne logge ind.',
        Name: 'Navn',
        Language: 'Sprog',
        NewPassword: 'Nyt password',
        ConfirmPassword: 'Bekræft Password',
        Submit: 'Gem'
    },

    TransactionList: {
        Type: 'Type',
        Operator: 'Operatør',
        When: 'Tidspunkt',
        Amount: 'Værdi',
        Currency: 'Valuta',
        Transactions: 'Transaktioner',
        Device: 'Maskin ID',
        SalesDay: 'Omsætningsdag',
        HoverDeposit: 'Deponeringer',
        HoverSalesIn: 'Inskud',
        HoverSalesOut: 'Hævninger',
        HoverManualDeposit: 'Manuel deponering',
        HoverCollection: 'Afhentning',
        HoverCollectionNotes: 'Afhentning af sedler',
        HoverCollectionCoins: 'Afhentning af mønter',
        HoverCollectionEnvelope: 'Afhentning af manuelle deponeringer',
        HoverCollectionOK: 'Afhentning bekræftet',
        HoverCollectionNotesOK: 'Afhentning af sedler bekræftet',
        HoverCollectionCoinsOK: 'Afhentning af mønter bekræftet',
        HoverCollectionEnvelopeOK: 'Afhentning af manuelle deponeringer bekræftet',
        HoverCollectionNOK: 'Afhentning difference',
        HoverCollectionNotesNOK: 'Afhentning af sedler difference',
        HoverCollectionCoinsNOK: 'Afhentning af mønter difference',
        HoverCollectionEnvelopeNOK: 'Afhentning af manuelle deponeringer difference',
        HoverDrain: 'Tøm',
        HoverRefill: 'Genfyld',
        HoverExchange: 'Veksling',
        HoverExchangeIn: 'Veksling ind',
        HoverExchangeOut: 'Veksling ud',
        HoverCounterfeit: 'Falsk seddel',
        HoverInternal: 'Intern transaktion',
        HoverNOP: 'Ingen funktion'
    },

    TransactionDayList: {
        Date: "Dato",
        Sales: "Indskud",
        Pickup: "Afhentning",
        Balance: "Beholdning",
        TransactionDays: "Transaktionsdage"
    },

    TransactionDay: {
        Date: "Dato",
        Sales: "Indskud",
        Pickup: "Afhentning",
        Balance: "Beholdning",
        TransactionDays: "Transaktionsdage",
        ExportTransactions: "Transaktioner"
    },

    TransactionDatePicker: {
        Date: 'Dato'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/dk.js